var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Canada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M36,8.027C32.655,5.51,28.509,4,24,4s-8.655,1.51-12,4.027v31.946C15.345,42.49,19.491,44,24,44 s8.655-1.51,12-4.027V8.027z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M44,24c0-6.537-3.15-12.323-8-15.973v31.946C40.85,36.323,44,30.537,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M4,24c0,6.537,3.15,12.323,8,15.973V8.027C7.15,11.677,4,17.463,4,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M33,23h-3l-0.039-1.984l-2.313,1.156L28,17l-2,1l-1.992-3L22,18l-2-1l0.352,5.145l-2.313-1.129 c0,0-0.043,1.973-0.039,1.984h-3l2,3l-2,1l4,2v2c0,0,2.536-0.138,4-0.212V33h2v-2.212C26.464,30.862,29,31,29,31v-2l4-2l-2-1L33,23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Canada);
export default __webpack_public_path__ + "static/media/icons8-canada.0ab4fbdf76abd5f4534afb8c76781925.svg";
export { ForwardRef as ReactComponent };